import { useEventNameMatch } from '@shared/components/AuthProvider/AuthProvider.utils';
import { EventType } from '@graphql/generated-base';
import { useGuestIdentificationEligibilityQuery } from './GuestIdentificationDialog.graphql.generated';

export const useGuestIdentificationDialogController = () => {
  const { eventName } = useEventNameMatch();

  // Note: this hook is only reached when the provider's outer gate has
  // already filtered out admins-in-iframe and preview URLs.
  const { data } = useGuestIdentificationEligibilityQuery({
    variables: { eventHandle: eventName || '' },
    batchMode: 'fast',
    ssr: false,
    skip: !eventName,
  });

  const event = data?.eventByName;
  const eventType = event?.info?.eventType;
  const activeSession = event?.activeSession;
  const hasIdentity = activeSession?.hasIdentity;
  const personFullName = activeSession?.person?.fullName;
  const eventId = event?.id ?? '';

  // True when the current visitor is a candidate for email-based identification:
  // a general event with no active session identity. Whether we auto-open the
  // dialog or show the sticky "Find your invitation" button is decided
  // downstream based on dismissal state.
  const canIdentifyGuest = eventType === EventType.general && !hasIdentity && !personFullName?.length && !!eventId;

  return {
    canIdentifyGuest,
    eventId,
    eventName: eventName ?? '',
  };
};
